import { store } from './store';
import {SET_COUNTRIES, SET_DICTIONARIES, SET_USER} from './mutations';

export default {

  FETCH_DICTIONARIES: async ({ commit }) => {
    const response = await axios.get('/dictionary');
    commit(SET_DICTIONARIES, response.data.dictionaries);
    commit(SET_USER, response.data.user);
    commit(SET_COUNTRIES, response.data.countries);
  },

  fetchConfiguration: ({commit}, endpoint) => {
    return new Promise((resolve, reject) => {
       axios.get(endpoint)
           .then((response) => {
               commit('setConfiguration', response.data);
               resolve();
           })
           .catch((error) => {
               reject(error);
           });
    });
  },
  fetchMenu: ({ commit }, endpoint) => {
    return new Promise((resolve, reject) => {
      axios.get(endpoint)
        .then((response) => {
          if (response.data) {
            commit('setMenu', response.data);
            resolve();
          }
          reject();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  storeMenu: async ({ commit }, endpoint) => {
    await axios.patch(
      endpoint, {
        menu: store.state.menu,
      });
  },

  fetchSettings: ({commit}) => {
    return new Promise((resolve, reject) => {
      axios.get('/settings/all')
          .then((response) => {
            commit('setSettings', response);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
    });
  },

  fetchSentToMobileAppAt: ({commit}, endpoint)  => {
      return new Promise((resolve, reject) => {
          axios.get(endpoint)
              .then((response) => {
                  commit('setSentToMobileAppAt', response.data.sentToMobileAppAt);
                  resolve();
              })
              .catch((error) => {
                  reject(error);
              });
      });
  },
};
